export async function getBarChart() {
  try {
    const data = {
      token: localStorage.getItem("token_royal"),
    };

    const response = await fetch(
      `${process.env.REACT_APP_API}/totalvisitaswill`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }
    );

    const result = await response.json();
    console.log(result);
    if (result.message) {
      console.error(
        result.message || "No se encontraron datos en la respuesta."
      );
      return [
        {
          name: "Clics",
          data: [],
        },
      ];
    } else {
      return [
        {
          name: "Clics",
          data: [
            result.facebook,
            result.instagram,
            result.whatsapp,
            result.directlink,
          ], // Asegúrate que esto es un array de números
        },
      ];
    }
  } catch (error) {
    console.error("Error al obtener los datos:", error);
    return [
      {
        name: "Clics",
        data: [],
      },
    ];
  }
}
